export const handleEscKeyPress = (e: KeyboardEvent, onClose: () => void) => {
    if (e.key === 'Escape') {
        onClose()
    }
}
